import React, { useState } from "react";
import { notification, Row } from "antd";
import s from "./SignIn.module.scss";
import { useTranslation } from "react-i18next";
import Header from "../../pages/LandingPage/components/Header/LandingHeader";
import MobileLoginHeader from "../../components/MobileHeader/MobileLoginHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router";

const SignIn = () => {
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  return (
    <div>
      {width > 500 ? <Header /> : <MobileLoginHeader />}
      <div className={s.login}>
        {contextHolder}
        <div className={s.logo_wrapper}>
          <img src="/logo.png" className={s.main_logo} />
          <div className={s.logo}>DIGITAL TRANSIT HUB</div>
        </div>
        <div className={s.main}>
          <Link
            to="/login"
            target="_blank"
            rel="noopener noreferrer"
            className={s.logo_item}
          >
            <img src="/images/smart_transit_logo.png" className={s.logo_img} />
          </Link>
          <div className={s.logo_item}>
            <img src="/images/trade_unit_logo.png" className={s.logo_img} />
          </div>
          <Link
            to="https://portal.wwsg.ge"
            target="_blank"
            rel="noopener noreferrer"
            className={s.logo_item}
          >
            <img src="/images/ncts_logo.png" className={s.logo_ncts} />
          </Link>
          <Link
            to="#"
            target="_blank"
            rel="noopener noreferrer"
            className={s.logo_item}
          >
            <img
              src="/images/ai_broker_logo.jpg"
              className={s.logo_ai_broker}
            />
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SignIn;
